// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mx-1";
export var messageSideRight = "_mx-2";
export var subscribeToBackInStockBubbleContainer = "_mx-0";